<template>
  <button
    class="ws-button"
    :class="[{red:red,white:white,narrow:narrow,'out-line':outLine,disable:disable,'flat-button':flatButton,'short-button':shortButton,'medium-button':mediumButton,primary:primary,width200:width200,'width-stretch':widthStretch,'light-blue':lightBlue,mt40:mt40,'non-min-width':nonMinWidth,rectangle},btnStyle]"
    @click="$_onClick('click')"
  >
    <router-link
      v-if="to"
      :to="to"
      class="ws-button__content"
    >
      <i
        v-if="leadingIcon && !isloading"
        :class="leadingIcon"
        class="ws-button__icon"
      />
      <p
        v-if="!isloading"
        class="ws-button__text"
        :class="{'no-wrap': noWrap}"
      >
        <slot />
      </p>
      <WsLoading :primary="outLine || white" v-else />
    </router-link>
    <div
      v-else
      class="ws-button__content"
    >
      <i
        v-if="leadingIcon && !isloading"
        :class="leadingIcon"
        class="ws-button__icon"
        @click="$_onClick('click-leading-icon')"
      />
      <p
        v-if="!isloading"
        class="ws-button__text"
        :class="{'no-wrap': noWrap}"
        @click="$_onClick('click-content')"
      >
        <slot />
      </p>
      <WsLoading :primary="outLine || white" v-else />
      <i
        v-if="trailingIcon && !isloading"
        :class="trailingIcon"
        class="ws-button__icon trailing-icon"
        @click="$_onClick('click-trailing-icon')"
      />
    </div>
  </button>
</template>
<script>
export default {
  name: "WsButton001",
  props: {
    btnStyle: {
      type: String,
      default: "",
    },
    nonMinWidth: {
      type: Boolean,
      default: false,
    },
    mt40: {
      type: Boolean,
      default: false,
    },
    outLine: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    white: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    red: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    flatButton: {
      type: Boolean,
      default: false,
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    width200: {
      type: Boolean,
      default: false,
    },
    shortButton: {
      type: Boolean,
      default: false,
    },
    mediumButton: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: "",
    },
    primary: {
      type: Boolean,
      default: false,
    },
    widthStretch: {
      type: Boolean,
      default: false,
    },
    lightBlue: {
      type: Boolean,
      default: false,
    },
    trailingIcon: {
      type: String,
      default: "",
    },
    noWrap: {
      type: Boolean,
      default: false,
    },
    rectangle: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    $_onClick(type) {
      if (this.isloading || this.disable) return;
      this.$emit(type);
    },
  },
};
</script>